import React from "react";
import { Card, Form, Checkbox, Divider, Button, InputNumber, Col, Row, Modal, Input, message, Radio } from 'antd';

import NHFetch from "../../../utils/NHFetch";
import NHSelect from "../../common/NHSelect";
import NHFormItem from '../../common/NHFormItem';
import { getLoginUser } from "../../../utils/NHCore";
import PropTypes from 'prop-types';
import { NHModal, NHConfirm } from '../../common/NHModal';

const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;
const basicUrl = "/yxxc/";
const hjdm = "GD001_3";   //环节代码
const jfxtBasicUrl = 'api/zhxg-jfxt/';
const ztxyUrlPath = "/ztxy/swbl/lstd"; //基础路径
/**
 * 绿色通道
 * Author: xuguanglin@ly-sky.com
 * Created on: 2021-7-4
 * Version: 1.0
 */
class Lstd extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            editable: true,
            show: false,
            hjblztData: {}, //环节办理状态信息
            lstdData: {}, //学生绿色通道办理信息
            yjje: 0,
            studentData: {},
            loading: false,
            previewVisible: false,
            judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'],   //可以导入的图片格式
        }
    }

    //渲染前获取 绿色通道办理原因
    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {

        if ('studentData' in nextProps) {
            const studentData = nextProps.studentData;

            //查询到学生信息时才显示绿色通道环节办理业务项
            if (Object.keys(studentData).length !== 0) {

                //查询到不同学生，查找该学生应缴费用
                if (JSON.stringify(this.state.studentData) === '{}' || this.state.studentData !== studentData) {
                    this.setState({ studentData: studentData });
                    this.getLstdYjjeData(studentData);
                    this.getLstdData(studentData);
                }
                this.setState({ show: true });

            } else {
                this.setState({ show: false });
            }
        }

        if ('hjblztData' in nextProps) {
            const hjblztData = nextProps.hjblztData;
            const lstdData = this.state.lstdData;

            if (hjblztData) {
                this.setState({ hjblztData: hjblztData });
            } else {
                this.setState({ hjblztData: hjblztData });
            }
            if (lstdData.sjly == 2) {
                this.setState({ editable: false });
            }

        }

    }



    /**
     * * 获取学生应缴费用信息
     *
     * @memberof Lstd
     */
    getLstdYjjeData = (studentData) => {
        const { xsid } = studentData;
        NHFetch(jfxtBasicUrl + 'yxjk/getTotalYjje', 'GET', { xsid: xsid })
            .then(res => {
                if (res && res.data) {
                    this.setState({ yjje: res.data });
                } else {
                    this.setState({ yjje: 0 });
                }
            })
    }

  

    /**
     * * 获取学生绿色通道办理数据
     *
     * @memberof Lstd
     */
    getLstdData = (studentData) => {
        const { xsid } = studentData;
        NHFetch(ztxyUrlPath + '/getLstdData', 'GET', { xsid: xsid })
            .then(res => {
                if (res && res.data) {
                    this.setState({ lstdData: res.data, editable: false });
                    // this.getDkyhMc(res.data);

                } else if (res.data == null) {
                    this.setState({ lstdData: {}, editable: true });

                }

            }).catch((ress) => {
                this.setState({ lstdData: {}});
            })
    }


    //确认办理
    handleSubmit = () => {

        const { xsid } = this.props.studentData;

        if (!xsid) {
            message.error("环节办理失败,请先查询学生信息！");
            return;
        }

        const form = this.props.form;

        //校验
        form.validateFields((err, formData) => {
            if (err) {
                return;
            }
            const { pkid } = this.state.hjblztData;
            const { xsid } = this.state.studentData;
            let userId = getLoginUser() ? getLoginUser().userId : '';
            let params = { xsid: xsid, lchjid: pkid, formData: formData, yhbh: userId, hjdm: hjdm };
            this.setState({ loading: true })
            NHFetch(basicUrl + 'saveCustomLinkData', 'POST', params)
                .then(res => {
                    if (res) {
                        if (res.data == '1') {
                            this.setState({ loading: false })
                            message.success('环节办理成功！');
                            this.getLstdData(this.state.studentData);
                            //办理完成回调
                            const onFinish = this.props.onFinish;
                            if (onFinish) {
                                onFinish('submit');
                            }
                        } else {
                            this.setState({ loading: false })
                            message.error('环节办理失败，请重试！');
                        }
                    }
                    this.setState({ loading: false })
                })
        });
    }

    //取消办理
    handleCancel = () => {
        const { pkid } = this.state.hjblztData;
        const { xsid } = this.state.studentData;
        let userId = getLoginUser() ? getLoginUser().userId : '';
        let params = { xsid: xsid, hjdm: hjdm, yhbh: userId, lchjid: pkid };
        NHConfirm("是否确定取消办理？", () => {
            this.setState({ loading: true })
            NHFetch(basicUrl + 'cancelCustomLinkData', 'POST', params)
                .then(res => {
                    if (res) {
                        if (res.data == '1') {
                            this.setState({ loading: false, dkfsValue: "" })
                            message.success('环节办理取消成功！');
                            //取消办理完成回调
                            this.getLstdData(this.state.studentData);
                            const onFinish = this.props.onFinish;
                            if (onFinish) {
                                onFinish('cancel');
                            }
                        } else {
                            this.setState({ loading: false })
                            message.error('环节办理取消失败，请重试！');
                        }
                    }
                })
        }, "warn");
    }

    //打印报到单回调
    handlePrint = () => {
        let onPrint = this.props.onPrint;
        if (onPrint) {
            onPrint();
        }
    }

    //上一步
    handleLast = () => {
        let onLast = this.props.onLast;
        if (onLast) {
            onLast();
        }
    }

    //下一步
    handleNext = () => {
        let onNext = this.props.onNext;
        if (onNext) {
            onNext();
        }
    }



    render() {

        const { form, lchjData = {}, hasLast, hasNext } = this.props;
        const { editable, lstdBlyy, show, lstdData, yjje, loading, previewVisible, previewImage, dkyhmc, dkfsList, dkfsValue } = this.state;

        const { sfdybdd = '0' } = lchjData; //是否打印报到单

        const formItemLayout = { //表单项布局
            labelCol: {
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 10 },
                lg: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 10 },
                lg: { span: 8 },
            }
        }

        return (

            <div>

                <Card type="inner" title="绿色通道业务信息">
                    {
                        editable ?
                            <div>
                                {
                                    show ?
                                        <Form>
                                            <NHFormItem id={"hjje"} required={true} label={"缓交金额"}
                                                form={this.props.form} formItemLayout={formItemLayout} >
                                                <InputNumber style={{ width: '300px' }} max={9999999}
                                                    formatter={value => value ? `￥${value}` : ''} parser={value => value.replace('￥', '')} />
                                            </NHFormItem>
                                            <NHFormItem id={"xfhj"} required={true} label={"学费缓交"}
                                                form={this.props.form} formItemLayout={formItemLayout} >
                                                <InputNumber style={{ width: '300px' }} max={9999999}
                                                    formatter={value => value ? `￥${value}` : ''} parser={value => value.replace('￥', '')} />
                                            </NHFormItem>
                                            <NHFormItem id={"zsfhj"} required={true} label={"住宿费缓交"}
                                                form={this.props.form} formItemLayout={formItemLayout}
                                            >
                                                <InputNumber style={{ width: '300px' }} max={9999999}
                                                    formatter={value => value ? `￥${value}` : ''} parser={value => value.replace('￥', '')} />
                                            </NHFormItem>
                                            <NHFormItem id={"hjqx"} required={true} label={"缓交期限"}
                                                form={this.props.form} formItemLayout={formItemLayout}>
                                                <Input style={{ width: '100px' }} suffix="月" />
                                            </NHFormItem>
                                            <NHFormItem id={"sqsm"} required={true} label={"申请说明"}
                                                form={this.props.form} formItemLayout={formItemLayout}>
                                                <TextArea maxLength={80} placeholder="请填写申请理由" style={{ width: '600px' }} />
                                            </NHFormItem>
                                            <NHFormItem id={"shyj"} label={"审核意见"} required={true}
                                                form={this.props.form} formItemLayout={formItemLayout}>
                                                <TextArea placeholder={'审核意见'} autosize={{ minRows: 2, maxRows: 5 }} />
                                            </NHFormItem>
                                        </Form>
                                        : null
                                }
                            </div>
                            :
                            <div>
                                <Form>
                                    <FormItem {...formItemLayout} label={'缓交金额'}>
                                        <span>{lstdData.hjje}元</span>
                                    </FormItem>
                                    <FormItem {...formItemLayout} label={'学费缓交'}>
                                        <span>{lstdData.xfhj}元</span>
                                    </FormItem>
                                    <FormItem {...formItemLayout} label={'住宿费缓交'}>
                                        <span>{lstdData.zsfhj}元</span>
                                    </FormItem>
                                    <FormItem {...formItemLayout} label={'缓交期限'}>
                                        <span>{lstdData.hjqx}月</span>
                                    </FormItem>
                                    <FormItem {...formItemLayout} label={'申请说明'}>
                                        <span>{lstdData.sqsm}</span>
                                    </FormItem>
                                    <FormItem {...formItemLayout} label={'审核状态'}>
                                        <span>{lstdData.shzt === '1' ? '审核通过' : ''}</span>
                                    </FormItem>
                                    <FormItem {...formItemLayout} label={'审核时间'}>
                                        <span>{lstdData.shsj}</span>
                                    </FormItem>
                                    <FormItem {...formItemLayout} label={'审核意见'}>
                                        <span>{lstdData.shyj}</span>
                                    </FormItem>
                                </Form>
                            </div>
                    }
                </Card>
                <Divider style={{ margin: '40px 0 24px' }} />
                {
                    editable || (lstdData.shzt == '0' || lstdData.shzt == '3') ?
                        <Button type="primary" onClick={this.handleSubmit} loading={loading}>确认办理</Button>
                        : <Button type="primary" onClick={this.handleCancel} loading={loading}>取消办理</Button>
                }
                {
                    sfdybdd == '1' ? <Button type="primary" loading={this.props.loading} ghost style={{ marginLeft: 10 }} onClick={this.handlePrint}>打印报到单</Button> : null
                }
                {
                    hasLast ? <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleLast}>上一步</Button> : null
                }
                {
                    hasNext ? <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleNext}>下一步</Button> : null
                }
            </div>
        )
    }
}

Lstd.propTypes = {
    studentData: PropTypes.object, //学生信息
    hjblztData: PropTypes.object, //环节办理状态信息
    lchjData: PropTypes.object, //流程环节信息数据
    hasLast: PropTypes.bool, //是否有上一步
    hasNext: PropTypes.bool, //是否有下一步
    onLast: PropTypes.func, //上一步事件回调
    onNext: PropTypes.func, //下一步事件回调
    onFinish: PropTypes.func, //确认办理、取消办理完成回调
    onPrint: PropTypes.func, //打印报到单
}

const lstd = Form.create()(Lstd);
export default lstd


// WEBPACK FOOTER //
// ./components/yxxc/steps/ztxyLstd.js